export default "__VITE_ASSET__BBhJSkjq__"